import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "@forge/ui";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import { LoginPage } from "./pages/LoginPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { HomePage } from "./pages/HomePage";
import WorkoutsPage from "./pages/WorkoutsPage";
import FoodPage from "./pages/FoodPage";
import { ProgressPage } from "./pages/ProgressPage";
import { MessagesPage } from "./pages/MessagesPage";
import BookingsPage from "./pages/BookingsPage";
import PlansPage from "./pages/PlansPage";
import { ShopPage } from "./pages/ShopPage";
import { MorePage } from "./pages/MorePage";
import { PricingPage } from "./pages/PricingPage";
import ImportActivity from "./pages/ImportActivity";
import SettingsPage from "./pages/SettingsPage";

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/home" replace />} />
              <Route path="home" element={<HomePage />} />
              <Route path="workouts" element={<WorkoutsPage />} />
              <Route path="food" element={<FoodPage />} />
              <Route path="progress" element={<ProgressPage />} />
              <Route path="messages" element={<MessagesPage />} />
              <Route path="bookings" element={<BookingsPage />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="shop" element={<ShopPage />} />
              <Route path="more" element={<MorePage />} />
              <Route path="pricing" element={<PricingPage />} />
              <Route path="import" element={<ImportActivity />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
